export default "__VITE_ASSET__CxNcoOWb__"